import { makeStyles } from "@material-ui/core";


export default makeStyles(() => ({
    alert: {
        "& .MuiAlert-action": {
            alignItems: "flex-start"
        }
    }
}));